import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';

class Occurrence extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			emp : '',
			ocdate : '',
			remark : '',
			posts : [],
			_message : '',
			alertClass :'',
			 id : '',
			_redirect : false,
			data : []
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onClick = this.onClick.bind(this);
	}
	
	onClick(e){
		
		document.getElementById("occform").reset();
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.emp && this.state.ocdate && this.state.remark){
			$("#showLoader").show();
			PostData('academic/addoccurrence',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Occurrence Register Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("occform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	/** remove function **/
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 
          $("#showLoader").show();		
			PostData('academic/deleteoccurrence',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Occurrence Details Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Occurrence Details',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	/** pass id to update value **/
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getemployee();
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();
		GetData('academic/getoccurrence').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
	/** get Employee **/
	getemployee(){
		
		GetData('employee/getemployee').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
  render() {
	
	/** Redirect to update page **/
	if(this.state._redirect){
		  
		return (<Redirect to={'/academic/occurrence/editoccurrence/' + this.state.idd} />);

	}
	
	  var items = this.state.posts;
	
    return (
		<div>
		  <AcademicPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="5">
					<Card>
					  <form action="" method="post" role="form" id="occform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Occurrence Register</strong>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Employee Name <span className="text-danger">*</span></Label>
								  <select name="emp" onChange={this.onChange} className="form-control" id="clas" required> 
									<option value="">Select Employee</option>
									{
										items.map(function (item) {
											return <option value={item.id }>{item.empname}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Date <span className="text-danger">*</span></Label>
								  <Input type="date" name="ocdate" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Remarks <span className="text-danger">*</span></Label>
								  <Input type="textarea" name="remark" required onChange={this.onChange} rows="5"/>
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				  <Col md="7">
				   <Card>
					<CardBody>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Employee Name</th>
								<th>Occurrence Date</th>
								<th>Remarks</th>
								<th>Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.data.map(item =>
							 
								<tr key = {item}>
									<td>{item.id}</td>
									<td>{item.empname}</td>
									<td>{item.date}</td>
									<td>{item.remarks}</td>
									<td>
										<button name="editacyear" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
										&nbsp;&nbsp;
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>
				  
							 )}
						</tbody>
					</Table>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Occurrence;


// WEBPACK FOOTER //
// ./src/occurrence/Occurrence/Occurrence.js